import { useState } from "react";
import { Link } from "react-router-dom";
import NetworkGraph from "./components/NetworkGraph";
import Reveal from "./components/Reveal";
import {
  IconGear, IconHeadset, IconMonitor, IconGlobe, IconCloud,
  IconDatabase, IconChat, IconShield, IconChart, IconBook,
  IconHelp, IconClock,
} from "./components/Icons";

const KB_CATEGORIES = [
  {
    color: "#0066FF",
    Icon: IconGear,
    title: "Gestão de TI & MSP",
    desc: "Conceitos de MSP, SLA, monitoramento e gestão de infraestrutura.",
    to: "/servicos/gestao-ti",
  },
  {
    color: "#0EA5E9",
    Icon: IconHeadset,
    title: "Suporte & Chamados",
    desc: "Como abrir chamados, prioridades, SLA e acompanhamento de atendimentos.",
    to: "/servicos/suporte",
  },
  {
    color: "#00C2A0",
    Icon: IconMonitor,
    title: "Acesso Remoto",
    desc: "Como baixar e usar o RustDesk sepolTECH para suporte remoto.",
    to: "/servicos/acesso-remoto",
  },
  {
    color: "#1A6CF6",
    Icon: IconGlobe,
    title: "sepolHOSTING",
    desc: "Configuração de e-mail, cPanel, domínios, FTP e hospedagem de sites.",
    to: "https://sepolhost.com.br/",
  },
  {
    color: "#0091FF",
    Icon: IconCloud,
    title: "sepolDRIVE",
    desc: "Instalação do cliente Nextcloud, sincronização e compartilhamento de arquivos.",
    to: "/produtos/sepol-drive",
  },
  {
    color: "#3ABEFF",
    Icon: IconDatabase,
    title: "sepolBACKUP",
    desc: "Como funciona o backup gerenciado, políticas de retenção e restauração.",
    to: "/produtos/sepol-backup",
  },
  {
    color: "#00C2A0",
    Icon: IconChat,
    title: "sepolCHAT",
    desc: "Configuração de atendentes, departamentos, WhatsApp e relatórios.",
    to: "/produtos/sepol-chat",
  },
  {
    color: "#7B3FF2",
    Icon: IconShield,
    title: "sepolSECURITY",
    desc: "Bitdefender GravityZone: políticas, exclusões, relatórios e alertas.",
    to: "/produtos/sepol-security",
  },
  {
    color: "#22C55E",
    Icon: IconChart,
    title: "ERP Bruning",
    desc: "Primeiros passos, módulos disponíveis e dicas de uso do sistema.",
    to: "/produtos/ERP",
  },
];

const KB_ARTICLES = [
  {
    Icon: IconMonitor,
    text: "Como usar o Acesso Remoto sepolTECH (RustDesk)",
    to: "/servicos/acesso-remoto",
  },
  {
    Icon: IconGear,
    text: "O que é um MSP e como funciona a gestão de TI terceirizada",
    to: "/faq#msp",
  },
  {
    Icon: IconHelp,
    text: "Perguntas frequentes sobre serviços e produtos sepolTECH",
    to: "/faq",
  },
  {
    Icon: IconCloud,
    text: "sepolDRIVE: diferença entre nuvem privada e Google Drive",
    to: "/produtos/sepol-drive",
  },
  {
    Icon: IconShield,
    text: "Por que antivírus comum não é suficiente — EPP vs EDR explicado",
    to: "/produtos/sepol-security",
  },
];

export default function BaseConhecimento() {
  const [search, setSearch] = useState("");

  const filteredCategories = KB_CATEGORIES.filter((cat) => {
    const term = search.trim().toLowerCase();
    if (!term) return true;
    return (
      cat.title.toLowerCase().includes(term) ||
      cat.desc.toLowerCase().includes(term)
    );
  });

  return (
    <>
      {/* ═══════════════ ABERTURA ═══════════════ */}
      <section className="page-hero">
        <div className="page-hero__bg"></div>
        <div className="page-hero__grid"></div>
        <NetworkGraph variant="hero" className="page-hero__network" />
        <div className="container" style={{ textAlign: "center" }}>
          <div className="tag animate-up">
            <IconBook style={{ width: "13px", height: "13px" }} />
            Documentação &amp; Tutoriais
          </div>
          <h1
            className="section-title animate-up animate-up--d1"
            style={{ fontSize: "clamp(32px,5vw,52px)" }}
          >
            Base de <span className="text-blue">Conhecimento</span>
          </h1>
          <p
            className="animate-up animate-up--d2"
            style={{
              fontSize: "17px",
              color: "var(--text-secondary)",
              maxWidth: "520px",
              margin: "16px auto 36px",
              lineHeight: "1.7",
            }}
          >
            Guias, tutoriais e artigos técnicos para ajudar você a usar e
            entender os serviços e produtos sepolTECH.
          </p>
          <div className="search-bar animate-up animate-up--d3">
            <input
              type="text"
              placeholder="Buscar artigos, tutoriais e guias..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <button type="button">Buscar</button>
          </div>
        </div>
      </section>

      {/* ═══════════════ CATEGORIAS ═══════════════ */}
      <section className="section">
        <div className="container">
          <Reveal className="section-header">
            <div>
              <div className="tag">Categorias</div>
              <h2 className="section-title">
                Navegue por <span className="text-blue">categoria</span>
              </h2>
            </div>
          </Reveal>
          <div className="kb-grid">
            {filteredCategories.map((cat, i) =>
              cat.to ? (
                <Reveal
                  as={Link}
                  to={cat.to}
                  className="kb-card"
                  delay={i * 0.05}
                  style={{ "--kb-color": cat.color }}
                  key={cat.title}
                >
                  <span className="kb-card__icon" style={{ color: cat.color }}>
                    <cat.Icon style={{ width: "30px", height: "30px" }} />
                  </span>
                  <div className="kb-card__title">{cat.title}</div>
                  <div className="kb-card__desc">{cat.desc}</div>
                  <div className="kb-card__count">→ Ver página completa</div>
                </Reveal>
              ) : (
                <Reveal
                  className="kb-card"
                  delay={i * 0.05}
                  style={{ "--kb-color": cat.color }}
                  key={cat.title}
                >
                  <span className="kb-card__icon" style={{ color: cat.color }}>
                    <cat.Icon style={{ width: "30px", height: "30px" }} />
                  </span>
                  <div className="kb-card__title">{cat.title}</div>
                  <div className="kb-card__desc">{cat.desc}</div>
                  <div className="kb-card__count">
                    <IconClock style={{ width: "12px", height: "12px" }} />
                    Em breve
                  </div>
                </Reveal>
              )
            )}
          </div>
        </div>
      </section>

      {/* ═══════════════ ARTIGOS EM DESTAQUE ═══════════════ */}
      <section className="section section--alt">
        <div className="container" style={{ maxWidth: "800px" }}>
          <Reveal className="text-center" style={{ marginBottom: "48px" }}>
            <div className="tag">Em destaque</div>
            <h2 className="section-title">
              Artigos mais <span className="text-blue">acessados</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="card" style={{ padding: "8px 0" }}>
            {KB_ARTICLES.map((article) => (
              <Link
                to={article.to}
                className="kb-article"
                style={{ padding: "16px 24px" }}
                key={article.text}
              >
                <span className="kb-article__icon">
                  <article.Icon style={{ width: "16px", height: "16px" }} />
                </span>
                <span>{article.text}</span>
                <span className="kb-article__arrow">→</span>
              </Link>
            ))}
          </Reveal>
          <div style={{ textAlign: "center", marginTop: "32px" }}>
            <p style={{ fontSize: "14px", color: "var(--text-muted)" }}>
              Não encontrou o que procura? Nossa equipe pode ajudar.
            </p>
            <Link to="/contato" className="btn btn-outline" style={{ marginTop: "16px" }}>
              Falar com suporte →
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
